import transHelpers from '@videotools/js/util/transHelpers';

export const ATHLETE_UNKNOWN_KEY = 'unknown';

export const ATHLETE_ALL_KEY = 'all';

export const ATHLETE_UNKNOWN_ENTITY = {
	id:   ATHLETE_UNKNOWN_KEY,
	name: transHelpers.transUcfirst('one.no_athlete'),
};

export const TAB_EVENT_TAGS = 'event-tags';
export const TAB_ATHLETE_TAGS = 'athlete-tags';
